import Cookies from 'js-cookie';

theme.shoppingControls = (function() {
    var _shoppingControls = {};
    _shoppingControls.$quantity = $('#buy-now-button__wrapper');

    _shoppingControls.getCartItemObject  = function(targetEl) {
        var $control = $(targetEl).closest('[data-quantity-shopping-container]');
        var productId = $control.attr('data-quantity-shopping-container');
        var $qtyInput = $control.find('[data-quantity-input]');
        var $qtyProxy = $control.find('[data-quantity-text]');
        var qty = parseInt($qtyInput.val());
        var stock = parseInt($qtyInput.attr('data-stock'));

        return {
            $control: $control,
            id: productId,
            qty: qty,
            stock: stock,
            $qtyInput: $qtyInput,
            $qtyProxy: $qtyProxy
        }
    }

    _shoppingControls.registerControls = function(){

        _shoppingControls.$quantity.on('click', '[data-quick-shopping-control="sub"]', function(){
            var cartItem = _shoppingControls.getCartItemObject(this);
            var newQty = cartItem.qty - 1 > 0 ? cartItem.qty - 1 : 0;

            cartItem.$qtyInput.val(newQty);
            cartItem.$qtyProxy.html(newQty);

            $(window).trigger('dataLayer-add-update-qnty', newQty);
        });

        _shoppingControls.$quantity.on('click', '[data-quick-shopping-control="add"]', function(){
            var cartItem = _shoppingControls.getCartItemObject(this);
            var newQty = cartItem.qty + 1 <= cartItem.stock ? cartItem.qty + 1 : cartItem.qty;

            cartItem.$qtyInput.val(newQty);
            cartItem.$qtyProxy.html(newQty);

            $(window).trigger('dataLayer-add-update-qnty', newQty);
        });
    };

    _shoppingControls.init = function() {
        if(!_shoppingControls.$quantity.length) {
            console.warn('Cart Error');
            return;
        } else {

            _shoppingControls.registerControls();

        }
    };

    return _shoppingControls;
})();

$(document).ready(function() {

    if ( $('.item__controls-wrapper').length ) {
        theme.shoppingControls.init();
    }

    if ($('.product-single__meta-dx .related-color-products').length == 0 && $('#product-single__add-to-cart').length != 0) {
        $('#product-single__add-to-cart').css('border', '0');
    }

    if ($('.product-single__info .image-info').length == 0 && $('.product-single__info').length != 0) {
        $('.product-single__info').css('margin-top', '0');
    }

    $(document).on('click', '.quickbuy-product', function(e) {
        e.preventDefault();
        let $this = $(this);
        let $variantId = parseInt($(this).attr('data-id'));

        if(!$variantId || typeof $variantId == "undefined"){
            return;
        }

        let data = {
            'items': [{
            'id': $variantId,
            'quantity': 1
            }]
        };

        $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            data: data,
            success: function(data){
                $this.find('.add-product').css('display', 'none');
                $this.find('.added-product').css('display', 'block');

                $.ajax({
                    url: '/cart.js',
                    dataType: 'json',
                    success: function(cart) {
                       $('.ajaxcart__subtotal.price').html(theme.Currency.formatMoney(cart.total_price, "€{{amount_with_comma_separator}}"));

                       var $fs_country_list = $('#CartContainer').attr('data-freeShipping-meta').split(',');
                       var user_country = $('#CartContainer').attr('data-locale');
                       var threshold = parseInt($fs_country_list.find(fs => fs.includes(user_country)).split('||')[1])*100;
    
                       if(cart.total_price > threshold){
                        $('.has-shipping').css('display', 'none');
                        $('.not-shipping').css('display', 'block');
                       } else {
                        var free_shipping = threshold - cart.total_price;
                        $('.has-shipping').find('.price').html(theme.Currency.formatMoney(free_shipping, "€{{amount_with_comma_separator}}"));
                       }
                    }
                });
            },
            error: function(data){
                $this.parents('.product__meta').find('.error-message').css('display', 'block');
            }
        });
    });

});
